<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord(params.id)"
      title="Edit"
    />

    <feather-icon
      v-if="!enableCheckinModule"
      title="QR Code"
      icon="EyeIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="showQR(params)"
    />
    <feather-icon
      v-if="loggedInUserId != params.id"
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      title="Delete"
      @click="confirmDeleteRecord()"
    />

    <feather-icon
      v-if="enableCheckinModule"
      icon="KeyIcon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer ml-2"
      title="Reset Password"
      @click="resetPassword(params.id)"
    />

    <!-- @click="confirmDeleteRecord(params.id)" -->
    <vs-popup
      class="holamundo"
      :title="'QR of ' + params.FirstName + ' ' + params.LastName"
      :active.sync="popupQR"
    >
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/1 flex justify-center items-center">
          <img :src="QR" />
        </div>
        <div
          class="vx-col w-full md:w-1/1 mt-4 flex justify-center items-center"
        >
          <vs-button
            color="rgb(76, 139, 246)"
            type="filled"
            class="sub-btn"
            v-on:click="downloadQR"
            >Download</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Swal from "sweetalert2";
// Mixins
import commonMixin from "@/mixins/common";
import ls from "@/common/localStorage";
import { bus } from "@/main";
export default {
  name: "CellRendererActions",
  mixins: [commonMixin],
  data() {
    return {
      QR: null,
      popupQR: false,
      enableCheckinModule: JSON.parse(
        ls.getSessionValueByKey("UseOnlyGeoCheckinModule")
      ),
      loggedInUserId: JSON.parse(ls.getSessionValueByKey("UserId")),
    };
  },
  methods: {
    resetPassword(id) {
      var resval = document.getElementsByClassName("swal2-input");

      console.log("resval=====", resval);
      


      const { value: text } = Swal.fire({
        title: "Enter the Password you want to set for the User",
        input: "text",
        inputPlaceholder: "Enter 6-16 digit Password and hit the Submit button",
        showCancelButton: true,
        confirmButtonText: "Submit",
        inputAttributes: {
          autocomplete: "none",
        },
        inputValidator: (value) => {
          console.log("value====", value);

          this.$store
            .dispatch("attendeeManagement/resetPasswordForCheckinUser", {
              userId: id,
              password: value,
              forceChangePass: this.loggedInUserId == id ? false : true,
            })
            .then((res) => {
              this.$vs.notify({
                position: "top-center",
                color: "success",
                title: "User",
                text: "User Password updated successfully.",
              });
            })
            .catch((err) => {
              console.error(err);
            });
        },
      }).then(function (result) {});
    },
    editRecord(id) {
      //console.log(id);
      //id = window.btoa(id);
      if (this.enableCheckinModule) {
        bus.$emit("editAttendee", id);
      } else {
        this.$router
          .push({
            name: "attendee-edit",
            params: {
              AttendeeId: id,
            },
          })
          .catch(() => {});
      }
      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    confirmDeleteRecord() {
      const { value: text } = Swal.fire({
        title: "Do you want to Delete these Attendee's ?",
        input: "text",
        inputPlaceholder: "Type 'delete' and hit the Submit button",
        showCancelButton: true,
        confirmButtonText: "Submit",
        inputValidator: (value) => {
          if (value.toLocaleLowerCase().trim() == "delete") {
            this.deleteRecord();
          } else {
            return "Try again! Please type 'delete' and hit Submit.";
          }
        },
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.showDeleteSuccess()
      this.$vs.loading();
      /* UnComment below lines for enabling true flow if deleting user */
      this.$store
        .dispatch("attendeeManagement/removeRecord", {
          AttendeeId: this.params.id,
          Email: this.params.Email,
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            this.$store.dispatch("attendeeManagement/fetchAttendees");
            this.showDeleteSuccess();
          }
        })
        .catch((err) => {
          console.error(err);
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            title: "Delete",
            text: err.message,
          });
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Record Deleted",
        text: "The selected record was successfully deleted",
      });
    },
    showQR(params) {
      if (params.QR) {
        this.QR = params.QR;
        this.popupQR = true;
      } else {
        this.generateQR(params.id);
      }
    },
    downloadQR() {
      if (this.QR) {
        let filename =
          "QR_Attendee" + "_" + this.QR.substr(this.QR.lastIndexOf("/"));
        this.downloadImageFromURL(this.QR, filename);
      }
    },
    generateQR(id) {
      this.$vs.loading();
      this.$store
        .dispatch("attendeeManagement/generateQR", [id])
        .then((res) => {
          for (let item of res.data) {
            if (item.status == 0) {
              this.QR = item.data.QR;
            }
          }
          this.popupQR = true;
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            text: "Something went wrong!",
          });
        });
    },
  },
};
</script>
